import React from 'react';
import { MailIcon, InstagramIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Footer() {
  return <footer className="border-t-4 border-grape bg-plum text-white" data-id="element-53" data-mp="3ggtymjf7hl5r">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-8 text-center" data-id="element-54" data-mp="32onigxc1ze6b">
        <p className="font-display text-xl font-black text-white" data-id="element-55" data-mp="36pft9v0kpr4p">
          SIGMA SMART<span className="align-super text-xs" data-id="element-56" data-mp="36nd5lhmw8a35">™</span> — THE 100+ AI PROMPTS FOR ELECTRICAL ENGINEERS<span className="align-super text-xs" data-id="element-57" data-mp="3uftlblj5rpza">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-58" data-mp="37o7wzgy05fh">
          ⚡ Your engineering expertise. A more structured way to work with AI.
        </p>

        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/70" data-id="element-59" data-mp="3qcx9cdo4is4b">
          Organize your instructions. Structure technical requests. Prepare clearer drafts. Review outputs with greater discipline.
        </p>

        <div className="mt-7 flex justify-center" data-id="element-60" data-mp="2ez1joazlf0yu">
          <CTAButton size="md" data-id="element-61" data-mp="3l9k1v1qqp380">Get the 100+ AI Prompts for Electrical Engineers™ now</CTAButton>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-62" data-mp="3gaz3z8yymvmq">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-63" data-mp="3v7zw3dl2cslq">
            <MailIcon className="h-4 w-4 text-grape-soft" data-id="element-64" data-mp="3qazrl73v3xwq" /> soporte.sigmasmart@gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-65" data-mp="80nsyi3daocc">
            <InstagramIcon className="h-4 w-4 text-grape-soft" data-id="element-66" data-mp="htd1b43mfm3g" /> @sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-67" data-mp="ct78vlpj1vkb">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-68" data-mp="qsqd43f7wmrc">
            Terms & Conditions
          </a>
          <span data-id="element-69" data-mp="mthh0rwpgcsm">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-70" data-mp="mq3fflvv87m8">
            Privacy Policy
          </a>
          <span data-id="element-71" data-mp="yto9s3rqyhxw">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-72" data-mp="yuzbzz5jnhmw">
            Support
          </a>
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45" data-id="element-73" data-mp="18kiydesgttmi">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}